<template>
  <div class="dashboard-list-table">
    <div v-if="loader && localDashboards.length === 0" class="text-center mt-4">
      <Loader
        :size="'big'"
      />
    </div>
    <template v-else-if="user">
      <div class="card shadow-none">
        <div class="card-body bg-table">
          <div class="table-responsive">
            <table class="table align-middle table-row-dashed fs-6 gy-5 bg-table">
              <thead>
                <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                  <th>{{ $t('name') }}</th>
                  <th width="100">
                    {{ $t('details') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dashboard, index) in localDashboards" :key="index" class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                  <td>
                    <router-link :to="{ name: 'dashboards.show', params: { id: dashboard.id } }" class="link-color2">
                      {{ dashboard.name }}
                    </router-link>
                    <a :href="'https://docs.google.com/spreadsheets/d/'+dashboard.platform_id" v-if="dashboard.platform === 'SPREADSHEET'" target="_blank" rel="noopener noreferrer" class="ms-4 text-decoration-underline">Link do Spreadsheets</a>
                  </td>
                  <td class="text-center">
                    <router-link :to="{ name: 'dashboards.show', params: { id: dashboard.id } }" class="link-color3"  v-b-tooltip.hover :title="$t('see_more')">
                      <i class="fa fa-eye"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="text-center mb-6" v-if="localDashboards.length > 0 && totalPages > 1">
        <div class="d-flex flex-stack flex-wrap pt-5">
          <div class="fs-6 fw-semibold text-gray-700">
            {{ $t('pagination', { from: this.from, to: this.to, totalItems: this.total }) }}
          </div>
          <b-pagination
            class="custom-pagination"
            v-model="page"
            :total-rows="total"
            :per-page="itemsPerPage"
            @input="getDashboards"
            hide-goto-end-buttons
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import DashboardsService from '@/modules/dashboards/services/dashboards-service'
import { mapState } from 'vuex'

import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'DashboardsListTable',
  props: ['dashboards', 'reload'],
  components: {
    Loader
  },
  data () {
    return {
      filters: {
      },
      from: 0,
      localDashboards: [],
      loader: false,
      page: 1,
      itemsPerPage: 0,
      showIframeModal: false,
      total: 0,
      to: 0
    }
  },
  created () {
    if (this.dashboards) {
      this.localDashboards = this.dashboards
    } else {
      if (this.user) {
        this.getDashboards()
      }
    }
  },
  watch: {
    reload (newValue) {
      if (newValue) this.reset()
    },
    user (newUser) {
      this.getDashboards()
    },
    loader (newValue) {
      this.$emit('loaderListTable', newValue)
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Get dashboards
     */
    async getDashboards () {
      if (!this.user) return false

      this.loader = true
      try {
        const dashboards = await DashboardsService.getDashboards({
          companyId: this.user.company.id,
          page: this.page
        })
        this.localDashboards = dashboards.data
        this.total = dashboards.meta.total
        this.itemsPerPage = dashboards.meta.per_page
        this.totalPages = dashboards.meta.last_page
        this.to = dashboards.meta.to
        this.from = dashboards.meta.from
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Reset and reload
     */
    reset () {
      this.page = 1
      this.localDashboards = []
      this.getDashboards()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
